import request from '@/utils/zsm-requets'
/** 通过手机号获取前端用户
      mobile	手机号
      platformDict 平台
 */
export function getByMobileAndPlatform(info) {
  return request({
    url: '/zsm/api/front/getByMobileAndPlatform',
    method: 'post',
    params: info
  })
}

/**  更新用户信息
      mobile	手机号
      platformDict 平台
      code	平台账号	query	false	
      desc	平台介绍	query	false	
      fanNum	平台粉丝数	query	false	
      favNum	平台收藏数	query	false	
      likeNum	平台点赞数	query	false	
      mobile	手机号	query	false	
      name	平台名称	query	false	
      platformDict	平台类型	query	false	
      realName	真实姓名	query	false	
      videoNum	平台作品数	query	false	

 */
export function updateFront(info) {
  return request({
    url: '/zsm/api/front/update',
    method: 'post',
    params: info
  })
}



/** 通过前端id获取前端用户信息
      id	前端id
 */
export function getFront(id) {
  return request({
    url: '/zsm/api/front/get',
    method: 'post',
    params: {
      id
    }
  })
}



/** 通过前端id获取前端用户信息
      mobile	前端mobile
      id	前端id
 */
export function listDataFront(params) {
  return request({
    url: '/zsm/api/front/listData',
    method: 'post',
    params
  })
}

// 获取入驻信息
export function getEnroll(id) {
  return request({
    url: '/zsm/api/enroll/get',
    method: 'post',
    params: {
      id
    }
  })
}
